import useConnectWallet from "@/store/wallet/useConnectWallet"
import { useCallback, useState } from "react"

/**
 * usePendingStake - 获取待领取质押收益 Hook
 * 
 * 用于调用 RegularStaking 合约的 pendingStake 方法获取指定质押记录的待领取收益。
 * 
 * @returns {Object} 返回获取方法、数据和加载状态
 *   - getPendingStake: 执行获取待领取收益的函数
 *   - pendingStakeData: 待领取收益数据（bigint）
 *   - pendingStakeLod: 加载状态
 */
const usePendingStake = () => {
    // 存放数据
    const [pendingStakeData, setData] = useState<bigint>(BigInt(0))
    // loading
    const [pendingStakeLod, setLoading] = useState(false)
    // 获取合约实例和地址
    const { contractEvm: { RegularStaking }, address } = useConnectWallet()

    /**
     * 获取待领取质押收益
     * @param id - 质押记录的 ID
     * @returns 返回待领取收益（bigint）
     */
    const getPendingStake = useCallback(async (id: bigint) => {
        setLoading(true)
        if (RegularStaking) {
            try {
                // 调用合约的 pendingStake 方法
                const data = await RegularStaking.pendingStake(address, id)
                // 保存数据
                setData(data)
                setLoading(false)
                return data
            } catch (e) {
                console.log('usePendingStake', e);
            }
        }
        setLoading(false)
    }, [RegularStaking, address])

    return { pendingStakeData, pendingStakeLod, getPendingStake }
}

export default usePendingStake
